import { render, staticRenderFns } from "./BaseMailForm.vue?vue&type=template&id=23ac19f0&scoped=true&"
import script from "./BaseMailForm.vue?vue&type=script&lang=js&"
export * from "./BaseMailForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseMailForm.vue?vue&type=style&index=0&id=23ac19f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac19f0",
  null
  
)

export default component.exports